/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        $('.no-link > a').on("click", function() {
            return false;
        });

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
        // store the slider in a local variable
        var $window = $(window),
            flexslider = { vars:{} };

        // tiny helper function to add breakpoints
        function getGridSize() {
          return (window.innerWidth < 769) ? 2 :
                 (window.innerWidth < 993) ? 3 : 5;
        }

        $window.load(function() {
          $('.flexslider').each(function(index, el) {
            $(this).flexslider({
            animation: "slide",
            animationLoop: true,
            itemWidth: 210,
            itemMargin: 5,
            directionNav: false,
            slideshowSpeed: 3000,
            move: 1,
            minItems: getGridSize(), // use function to pull in initial value
            maxItems: getGridSize() // use function to pull in initial value
          });
          });
          
        });

        // check grid size on resize event
        $window.resize(function() {
          var gridSize = getGridSize();

          flexslider.vars.minItems = gridSize;
          flexslider.vars.maxItems = gridSize;
        });

        // init controller ScrollMagic
        var controller = new ScrollMagic.Controller();

        // build scene
        var scene = new ScrollMagic.Scene({
          triggerElement: ".seccion-formacion",
          duration: 150,
          offset: 50
        })
        .setTween(".contenido-formacion:nth-child(2) .logo-formacion", 1, {
          transform: "rotateY(180deg)"
        })
        // .setTween(".contenido-formacion:nth-child(2) .logo-formacion", 1, {
        //   transform: "rotate(90deg)"
        // })
        //.addIndicators({name: "icons 1"}) // add indicators (requires plugin)
        .addTo(controller);

        var scene2 = new ScrollMagic.Scene({
          triggerElement: ".seccion-formacion",
          duration: 150,
          offset: 200
        })
        .setTween(".contenido-formacion:nth-child(3) .logo-formacion", 1, {
          transform: "rotateY(180deg)"
        })
        // .setTween(".contenido-formacion:nth-child(3) .logo-formacion", 1, {
        //   transform: "rotate(90deg)"
        // })
        //.addIndicators({name: "icons 2"}) // add indicators (requires plugin)
        .addTo(controller);

        var scene3 = new ScrollMagic.Scene({
          triggerElement: ".seccion-formacion",
          duration: 150,
          offset: 350
        })
        .setTween(".contenido-formacion:nth-child(4) .logo-formacion", 1, {
          transform: "rotateY(180deg)"
        })
        // .setTween(".contenido-formacion:nth-child(4) .logo-formacion", 1, {
        //   transform: "rotate(90deg)"
        // })
        //.addIndicators({name: "icons 3"}) // add indicators (requires plugin)
        .addTo(controller);

        var scene4 = new ScrollMagic.Scene({
          triggerElement: ".seccion-formacion",
          duration: 150,
          offset: 500
        })
        .setTween(".contenido-formacion:nth-child(5) .logo-formacion", 1, {
          transform: "rotateY(180deg)"
        })
        //.addIndicators({name: "icons 4"}) // add indicators (requires plugin)
        .addTo(controller);

        var scene5 = new ScrollMagic.Scene({
          triggerElement: ".seccion-formacion",
          duration: 150,
          offset: 600
        })
        .setTween(".contenido-formacion:nth-child(6) .logo-formacion", 1, {
          transform: "rotateY(180deg)"
        })
        //.addIndicators({name: "icons 5"}) // add indicators (requires plugin)
        .addTo(controller);

        var scene6 = new ScrollMagic.Scene({
          triggerElement: ".seccion-formacion",
          duration: 150,
          offset: 700
        })
        .setTween(".contenido-formacion:nth-child(7) .logo-formacion", 1, {
          transform: "rotateY(180deg)"
        })
        //.addIndicators({name: "icons 6"}) // add indicators (requires plugin)
        .addTo(controller);

        var scene7 = new ScrollMagic.Scene({
          triggerElement: ".seccion-formacion",
          duration: 150,
          offset: 850
        })
        .setTween(".contenido-formacion:nth-child(8) .logo-formacion", 1, {
          transform: "rotateY(180deg)"
        })
        // .setTween(".contenido-formacion:nth-child(8) .logo-formacion", 1, {
        //   transform: "rotate(90deg)"
        // })
        //.addIndicators({name: "icons 7"}) // add indicators (requires plugin)
        .addTo(controller);

        var scene8 = new ScrollMagic.Scene({
          triggerElement: ".seccion-formacion",
          duration: 150,
          offset: 950
        })
        .setTween(".contenido-formacion:nth-child(9) .logo-formacion", 1, {
          transform: "rotateY(180deg)"
        })
        // .setTween(".contenido-formacion:nth-child(9) .logo-formacion", 1, {
        //   transform: "rotate(-90deg)"
        // })
        //.addIndicators({name: "icons 8"}) // add indicators (requires plugin)
        .addTo(controller);

        var scene9 = new ScrollMagic.Scene({
          triggerElement: ".seccion-formacion",
          duration: 150,
          offset: 1100
        })
        .setTween(".contenido-formacion:nth-child(10) .logo-formacion", 1, {
          transform: "rotateY(180deg)"
        })
        //.addIndicators({name: "icons 9"}) // add indicators (requires plugin)
        .addTo(controller);

        var scene10 = new ScrollMagic.Scene({
          triggerElement: ".seccion-formacion",
          duration: 150,
          offset: 1200
        })
        .setTween(".contenido-formacion:nth-child(11) .logo-formacion", 1, {
          transform: "rotateY(180deg)"
        })
        //.addIndicators({name: "icons 9"}) // add indicators (requires plugin)
        .addTo(controller);


      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'proyectos_implementados': {
      init: function() {
        // JavaScript to be fired on the about us page
        // store the slider in a local variable
        var $window = $(window),
            flexslider = { vars:{} };

        $window.load(function() {
          $('.flexslider-implementados').flexslider({
            animation: "slide",
          });
        });
      }
    },
    'page_template_template_transferencia_tecnologia': {
      init: function(){

        $( window ).load(function() {
          var current_url = window.location.href;
          var split_url = current_url.split("#");
          var tab_id = split_url[1];
          //alert(tab_id);
          if (typeof tab_id !== 'undefined') {
            tab_id = "#" + tab_id;
            $(tab_id).tab('show');
            $('.seccion-productos-tabs .nav-tabs .nav-item a').removeClass('active');
            $('.seccion-productos-tabs .nav-tabs .nav-item a[href="'+tab_id+'"]').addClass('active');
            $('.seccion-productos-tabs .tab-content .tab-pane').removeClass('active');
            $('.seccion-productos-tabs .tab-content ' + tab_id).addClass('active');
          }
        });

        // var count_tt = ($('.single-producto').length / 2) * 170;
        // console.log(count_tt);
        //
        // // init controller ScrollMagic
        // var controller_tt = new ScrollMagic.Controller();
        //
        // var tween_tt = TweenMax.staggerFromTo(".single-producto", 2, {'margin-top': '200px'}, {'margin-top': '0px', ease: Linear.easeOut}, 0.50);
        //
        // // build scene
        // var scene_tt = new ScrollMagic.Scene({
        //   triggerElement: ".seccion-productos-tabs",
        //   duration: count_tt,
        //   offset: 300
        // })
        // .setTween(tween_tt)
        // //.addIndicators({name: "icons 1"}) // add indicators (requires plugin)
        // .addTo(controller_tt);


      }
    },
    'lineas_de_formacion_template': {
      init: function(){
        $('.galeria-del-curso img').click(function() {
          var current_element = $(this).attr('data-target');
          var current_slide = $(this).attr('data-slide');
          //alert(current_slide);
          $(current_element).modal();
          $('.carousel').carousel(current_slide);
        });

        $( window ).load(function() {
          var current_curso = $('.form-box').attr('data-title');
          //alert(current_curso);
          $('.nombre-curso > input').attr('value', current_curso);
        });
      }
    },
    'page_template_template_lineas_formacion': {
      init: function(){
        $('.btn-subscribe').click(function() {
          /* Act on the event */
          var current_linea = $(this).attr('data-target');
          $('.form-curso .curso-actual').val(current_linea);
          $('.form-curso .curso-actual').attr('disabled', 'disabled');
          $('.form-curso').css('display', 'block');
          return false;
        });
      }
    },
    'lineas_de_formacion_template_default': {
      init: function(){
        $('.btn-subscribe').click(function() {
          /* Act on the event */
          var current_linea = $(this).attr('data-target');
          $('.form-curso .curso-actual').val(current_linea);
          $('.form-curso .curso-actual').attr('disabled', 'disabled');
          $('.form-curso').css('display', 'block');
          return false;
        });
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
